module.exports = __webpack_public_path__ + "static/media/w (28).a8e7587a.jpg";